export default {"src":"/_next/static/media/edgebravefirfox.16d360d9.svg","height":33,"width":80,"blurWidth":0,"blurHeight":0};